import { clientId, lpRequest } from '../../../../core/api/lp-request';

/** The fleet's drivers holding exactly this `{promisor_id, hub_id}` permission. Read without trips, which aren't shown. */
export const getDriversAssignedToHub = async (
  promisor_id: string,
  contract_id: string,
  hub_id: string
): Promise<any> => {
  const drivers = await lpRequest(`/client/${clientId()}/drivers`);

  return drivers.filter((driver: any) =>
    (driver.delivery_permissions || []).some(
      (permission: any) => permission.promisor_id === promisor_id && permission.hub_id === hub_id
    )
  );
};
